import clsx from 'clsx';
import parseStyle from 'style-to-js';

import { AnimatedBaseContainer } from '@commons/containers/AnimatedContainer';
import BaseContainer, { type BaseContainerProps } from '@commons/containers/BaseContainer';
import type { DrupalBlockAttributes } from '@commons/types/drupal';

import styles from './Wrapper.module.scss';

// Type definition for the BlockWrapper component properties.

type Props = BaseContainerProps & {
  attributes: DrupalBlockAttributes;
  animate?: boolean;
};

/**
 * BlockWrapper component.
 *
 * Wraps the block with a div element and applies the attributes.
 *
 * Also applies animation if enabled.
 * This could be extended in the future to support different animation types.
 */

const BlockWrapper = (props: Props) => {
  const { children, attributes, className, ref, animate = true, ...rest } = props;

  const { id, classes: blockClasses, style, attributes: blockAttributes } = attributes;

  const classes = clsx(styles.blockWrapper, className, blockClasses);
  const inlineStyles = style ? parseStyle(style) : undefined;

  const Component = animate ? AnimatedBaseContainer : BaseContainer;

  return (
    <Component
      id={id}
      ref={ref}
      style={inlineStyles}
      className={classes}
      {...rest}
      {...blockAttributes}
    >
      {children}
    </Component>
  );
};

export default BlockWrapper;
